import * as ActionTypes from "./actionTypes";
import {ActionSender} from "../../model/ActionSender";
import {QueryAvailableLicensesOpts} from "../../model/entitlement/QueryAvailableLicensesOpts";
import {
  LicenseWithOwnerAndSingleUserAssignments
} from "../../model/entitlement/LicenseWithOwnerAndSingleUserAssignments";
import {entApi} from "../../api";
import {LicenseAssignment} from "../../model/entitlement/LicenseAssignment";
import {buildActionThunk, forceUndefined} from "./actionHelpers";

/**
 * Queries information of licenses available to a user.
 * @param sender Component requesting for the action
 * @param orgId Id of the organization.
 * @param userId Id of the user.
 * @param queryAvailableLicensesOpts Options for the operation.
 */
export function queryAvailableLicenses(
  sender: ActionSender,
  userId: string,
  orgId?: string,
  queryAvailableLicensesOpts?: QueryAvailableLicensesOpts
): ActionTypes.AppThunkAction<ActionTypes.QueryAvailableLicensesAction> {

  return buildActionThunk<
    ActionTypes.QueryAvailableLicensesAction,
    LicenseWithOwnerAndSingleUserAssignments[]
  >(
    sender,
    ActionTypes.QUERY_AVAILABLE_LICENSES,
    async () =>
      await entApi.queryAvailableLicenses(userId, queryAvailableLicensesOpts),
    (type, availableLicenses) => ({
      type,
      userId,
      queryAvailableLicensesOpts,
      licenses: forceUndefined(availableLicenses),
      licenseAssignments: availableLicenses
        ? availableLicenses
            .filter((lic) => lic.assignments && lic.assignments.length !== 0)
            .flatMap((lic) => lic.assignments as LicenseAssignment[])
        : forceUndefined<LicenseAssignment[]>(),
    })
  );
}
